import React, { useMemo } from 'react'
import { Divider, Stack, Text } from '@chakra-ui/react'
import { NotificationCard } from '../NotificationCard'
import { useNotification } from 'contexts/notification'
import { NotificationStatus } from 'contexts/notification/types'

export const TabFavorite = () => {
  const { favoriteNotifications } = useNotification()

  const notificationsUnread = useMemo(() => {
    if (!favoriteNotifications) {
      return null
    }

    const draft = favoriteNotifications[NotificationStatus.UNREAD]

    if (!draft) {
      return null
    }

    return draft.original
  }, [favoriteNotifications])

  const notificationsRead = useMemo(() => {
    if (!favoriteNotifications) {
      return null
    }

    const draft = favoriteNotifications[NotificationStatus.READ]

    if (!draft) {
      return null
    }

    return draft.original
  }, [favoriteNotifications])

  const isBlank = useMemo(() => {
    if (!notificationsUnread && !notificationsRead) {
      return true
    }

    if (notificationsUnread?.length === 0 && notificationsRead?.length === 0) {
      return true
    }

    return false
  }, [notificationsRead, notificationsUnread])

  return (
    <Stack w="full" spacing="0" divider={<Divider />}>
      {isBlank ? (
        <Text
          pt="6"
          pb="3"
          display="flex"
          fontSize="xs"
          fontWeight="thin"
          fontStyle="italic"
          alignItems="center"
          justifyContent="center"
        >
          Nenhuma mensagem favoritada
        </Text>
      ) : (
        <>
          <Stack boxShadow="md" mb="2.5">
            {notificationsUnread &&
              notificationsUnread.map((notification) => (
                <NotificationCard key={notification.id} data={notification} />
              ))}
          </Stack>

          {notificationsRead && (
            <Stack divider={<Divider />}>
              {notificationsRead.map((notification) => (
                <NotificationCard key={notification.id} data={notification} />
              ))}
            </Stack>
          )}
        </>
      )}
    </Stack>
  )
}
